import { FC } from 'react';
import { Loading } from 'jbc-front/components/presenters/ui/Loading';
import { useReport } from '../../hooks/useReport';
import { ReportName } from '../../types';
import { Viewer } from './Viewer';
import { REPORT_MAP } from '../../consts';

// @ts-ignore
import { toBlob } from 'utils/url';
// @ts-ignore
import { saveAs } from 'file-saver';

export type ViewerProps = {
  reportName: ReportName;
  hidePrint?: boolean;
  printDisabledReason?: string;
  onClose: () => void;
};

export const ReportViewer: FC<ViewerProps> = ({ reportName, hidePrint = false, printDisabledReason, onClose }) => {
  const { report, loading } = useReport(reportName);
  const title = REPORT_MAP[reportName];

  const handleClickDownload = () => {
    if (!report) return;
    saveAs(toBlob(report.data, 'application/pdf'), `${title}.pdf`);
  };

  return (
    <Viewer>
      <Viewer.Header
        onClose={onClose}
        reportUrl={report?.url}
        title={title}
        hidePrint={hidePrint}
        printDisabledReason={printDisabledReason}
        onClickDownload={handleClickDownload}
      />
      {loading && <Loading />}
      {report && <Viewer.Pdf report={report.data} />}
    </Viewer>
  );
};
